<template>
  <div class="login">
    <div class="div login_div">

      <div align="left" class="login_right">
        <div class="padding-style">
          <i class="el-icon-user"></i>
          <input class="input" maxlength="12" v-model="username" type="text" placeholder="用户名" autofocus="autofocus" />
        </div>

        <div>
          <i class="el-icon-lock"></i>
          <input class="input" maxlength="16" v-model="password" type="password" placeholder="密码"
            autofocus="autofocus" />
        </div>

        <div class="imgcode-edit">
          <slide-verify ref="slideblock" @again="onAgain" @fulfilled="onFulfilled" @success="onSuccess" @fail="onFail"
            @refresh="onRefresh" :accuracy="10" :slider-text="text" :w="280" :h="120" :imgs="img_arr"></slide-verify>
        </div>

        <div>
          <input class="login-btn" type="submit" @click="login" value="登录">
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      msg: '',
      text: '向右滑',
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 1,
      img_arr: process.env.NODE_ENV === 'production' ? ['../static/img/1.jpg', '../static/img/2.jpg', '../static/img/3.jpeg'] : ['../static/img/1.jpg', '../static/img/2.jpg', '../static/img/3.jpeg'],
      is_pass: false
    }
  },
  methods: {
    onSuccess() {
      console.log('验证通过，耗时 +' + '毫秒');
      this.is_pass = true;
    },
    onFail() {
      console.log('验证不通过');
      this.is_pass = false;
    },
    onRefresh() {
      console.log('点击了刷新小图标');
    },
    onFulfilled() {
      console.log('刷新成功啦！');
    },
    onAgain() {
      console.log('检测到非人为操作的哦！');
      this.msg = 'try again';
      // 刷新
      this.$refs.slideblock.reset();
    },
    login() {
      let _this = this
      if (!this.username) {
        this.$msg('请输入用户名')
        return false
      }
      if (!this.is_pass) {
        this.$msg('请完成拼图')
        return false
      }
      if (!this.password) {
        this.$msg('请输入密码')
        return false
      }
      this.$post('/v1/admin/sign-in', { name: this.username, password: this.password })
        .then((res) => {
          console.log(res, '---------')
          if (res.data.status === 'success') {

            console.log(res.data.data, '====')
            localStorage.setItem('isShowMore', false)
              localStorage.setItem('communityId', res.data.data.b_id)
              localStorage.setItem('username', res.data.data.username);
              localStorage.setItem('auth_token', res.data.data.auth_token);
              localStorage.setItem('user_id', res.data.data.user_id);
              window.location.href = process.env.NODE_ENV === 'production' ? this.G.publicPath + '/' : '/';
          } else {
            this.$msg(res.data.msg)
          }
        });
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.login
  width:100%;
  height:100%;
  position: relative;
  background: linear-gradient(135deg,rgba(52,172,64,0.5),rgba(44,138,232,0.3),rgba(0,0,0,0.5),rgba(220,71,205,0.5),rgba(231,227,115,0.3));
  background-size: 500%;
  animation: bgAnimation 12s linear infinite;

  .login_div
    position: absolute;
    width: 400px;
    height: 400px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;

    .login_right
      float: right;
      width: 400px;
      height: 400px;
      padding-top:30px;
      background-color: #fff;
      border-radius: 8px;
      >div
        position: relative;
        padding-left: 68px;
        margin-bottom: 20px;
        i
          display: inline-block;
          height: 20px;
          width: 16px;
          margin: 12px 10px 15px 12px;
          position: absolute;
        input
          width: 280px;
          height: 36px;
          padding-left: 36px;
          font-size: 14px;
          border: none;
          border-radius: 6px;
          background: #F9F9F9;
          box-shadow: 1px 1px 4px 0px rgba(187,187,187,0.5);
      .imgcode-edit
        width: 280px;
        height: 180px;
        padding: 0;
        margin: 0 67px 20px;
        #slideVerify
          width:280px!important;

      .login-btn
        width: 280px;
        height: 36px;
        padding: 0;
        color: #ffffff;
        font-size: 14px;
        background: linear-gradient(180deg, #77ADEC 0%, #468CE6 100%);
        border-radius: 4px;
@keyframes bgAnimation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue